import { render } from "./Item3.vue?vue&type=template&id=50fc0579&scoped=true"
import script from "./Item3.vue?vue&type=script&lang=js"
export * from "./Item3.vue?vue&type=script&lang=js"

import "./Item3.vue?vue&type=style&index=0&id=50fc0579&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50fc0579"

export default script